import { FC, useState } from 'react';
import { IDish } from '../../../types/dishes.types';
import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { NavigationService } from '../../../services/navigation';
import { COLORS, FONTS } from '../../../constants';
import { Button } from '../../../components/Button';
import { convertPrice, convertToAmPm } from '../../../services/utils';
import RenderHTML from 'react-native-render-html';
import { IActivity } from '../../../types/activities.types';
import { htmlDecode } from '../../../services/utils/htmlDecode';
import { STYLE_VARS } from '../../../constants/style-vars';
import { isSameDate } from '../../../services/utils/dateConvert';
import dayjs from 'dayjs';
import { DATE_TYPE } from '../../../constants/activity';

interface ExtraActivityItemProps {
  item: IActivity;
  onAddToCart: (item: IActivity, peopleNum: number) => void;
  maxPeople?: number;
}

const ExtraActivityItem: FC<ExtraActivityItemProps> = ({
  item,
  onAddToCart,
  maxPeople = 100,
}) => {
  const [peopleNum, setPeopleNum] = useState<number>(1);

  const handleAdd = () => {
    if (peopleNum < maxPeople) {
      setPeopleNum((prevPeoleNum) => prevPeoleNum + 1);
    }
  };

  const handleMinus = () => {
    if (peopleNum > 1) {
      setPeopleNum((prevPeoleNum) => prevPeoleNum - 1);
    }
  };

  return (
    <View
      style={{
        width: '100%',
      }}
      key={item.id}
    >
      <TouchableOpacity
        style={{
          marginBottom: 7,
        }}
        onPress={() => {}}
      >
        <Image
          source={
            item.image
              ? {
                  uri: item.image,
                }
              : require('../../../assets/activities_image/image-1.png')
          }
          style={[
            {
              width: '100%',
              borderRadius: 18,
              height: 170,
            },
          ]}
        />
      </TouchableOpacity>
      <Text
        style={{
          fontFamily: FONTS.AvenirHeavy,
          fontWeight: '800',
          fontSize: 19,
          color: COLORS.BLACK,
          marginBottom: 8,
        }}
      >
        {item.name}
      </Text>
      <View
        style={{
          width: 60,
          height: 2,
          marginBottom: 10,
          backgroundColor: COLORS.RED_PRIMARY,
        }}
      />
      {item.date_type.value === DATE_TYPE.NORMAL ? (
        item.start_date === item.end_date ? (
          <Text style={styles.descriptionText}>
            {`${dayjs(item.start_date).format('MMMM DD, YYYY')}`}
          </Text>
        ) : (
          <>
            <Text style={styles.descriptionText}>
              {`Start: ${dayjs(item.start_date).format('MMMM DD, YYYY')}`}
            </Text>
            <Text style={styles.descriptionText}>
              {`End: ${dayjs(item.end_date).format('MMMM DD, YYYY')}`}
            </Text>
          </>
        )
      ) : (
        <Text style={styles.descriptionText}>{item.date_type.name}</Text>
      )}
      <View style={styles.timeWrapper}>
        <Text style={styles.timeText}>
          {`${convertToAmPm(item.start_time)} - ${convertToAmPm(
            item.end_time
          )}`}
        </Text>
      </View>
      <Text style={styles.descriptionText} numberOfLines={1}>
        {item.type}
      </Text>
      <Text style={styles.descriptionText} numberOfLines={1}>
        {item.venue}
      </Text>
      <Text
        style={{
          fontFamily: FONTS.AvenirMedium,
          fontWeight: '800',
          fontSize: 19,
          color: COLORS.RED_PRIMARY,
          marginBottom: 5,
        }}
      >
        {`HKD ${convertPrice(item.price)}`}
      </Text>
      <View style={{ marginBottom: 5 }}>
        <Text
          style={{
            fontFamily: FONTS.AvenirMedium,
            fontSize: 14,
            fontWeight: '500',
            color: COLORS.GREY,
          }}
        >
          {'Number Of People:'}
        </Text>
      </View>
      <View style={styles.countContainer}>
        <TouchableOpacity onPress={handleMinus} activeOpacity={1}>
          <Image
            style={styles.countBtnIcon}
            source={require('../../../assets/minus-red-icon.png')}
          />
        </TouchableOpacity>
        <Text
          style={{
            ...styles.countNumber,
            paddingHorizontal: 10,
          }}
        >
          {peopleNum}
        </Text>
        <TouchableOpacity activeOpacity={1} onPress={handleAdd}>
          <Image
            style={styles.countBtnIcon}
            source={require('../../../assets/add-icon.png')}
          />
        </TouchableOpacity>
      </View>
      <View
        style={{
          flexDirection: 'row',
        }}
      >
        <Button
          style={{
            paddingHorizontal: 20,
            paddingVertical: 10,
            backgroundColor: COLORS.RED_PRIMARY,
            borderRadius: 16,
          }}
          className=""
          text="Add to Cart"
          arrowRight={false}
          textStyle={{
            fontFamily: FONTS.AvenirMedium,
            fontWeight: '500',
            fontSize: 16,
            color: COLORS.WHITE,
          }}
          onPress={() => {
            onAddToCart(item, peopleNum);
          }}
        />
      </View>
    </View>
  );
};

export default ExtraActivityItem;

const styles = StyleSheet.create({
  countContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },
  countBtn: {},
  countBtnIcon: {
    width: 20,
    height: 20,
  },
  countNumber: {
    fontSize: 12,
    color: COLORS.BLACK,
    fontFamily: STYLE_VARS.avenirMediumFont,
  },
  descriptionText: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 15,
    fontWeight: '500',
    color: COLORS.GREY,
    marginBottom: 4,
  },
  timeWrapper: {
    borderRadius: 18,
    paddingVertical: 3,
    paddingHorizontal: 5,
    backgroundColor: COLORS.LIGHT_GREY,
    width: 130,
    marginBottom: 5,
  },
  timeText: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 11,
    fontWeight: '500',
    color: COLORS.BLACK,
    textAlign: 'center',
    lineHeight: 18,
  },
});
